import { render, staticRenderFns } from "./AppointmentMade.vue?vue&type=template&id=ef4b427e&"
import script from "./AppointmentMade.vue?vue&type=script&lang=js&"
export * from "./AppointmentMade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports